import { IFieldState } from '../store/applicationform/applicationFormTypes';

export const scrollToFieldWithError = (fieldStates: IFieldState[]) => {
    const element = document.getElementsByName(fieldStates[0].fieldName)?.[0] as HTMLElement | undefined;

    if (element) {
        setTimeout(() => {
            element?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 0);
    }
};
